"use client"

import PostLink from "@/components/PostLink"
import { formatDateSimple, toImageSrc } from "@/lib/utils"
import Image from "next/image"
import { LatestNewsArticle } from "../types"

interface NewsGridItemProps {
    article: LatestNewsArticle
}

const NewsGridItem = ({ article }: NewsGridItemProps) => {
    return (
        <div className="group flex flex-col">
            <PostLink href={`/${article.slug}`} locale={article.locale} postId={article.id} className="group block relative overflow-hidden rounded-lg">
                <div className="relative w-full sm:h-[254px] h-[160px]">
                    {article.imageUrl && (
                        <Image
                            src={toImageSrc(article.imageUrl)}
                            alt={article.title}
                            fill
                            className="object-cover transition-transform duration-300 group-hover:scale-105 image-hover"
                        />
                    )}
                </div>
            </PostLink>

            {article.categoryName && (
                <div className="sm:pt-2.5 pt-[6px] sm:pb-1 pb-[2px] text-xs leading-[18.6px] font-bold text-[#1AAF4D]">
                    {article.categoryName}
                </div>
            )}

            <div className="flex flex-col sm:gap-2.5 gap-[5px]">
                <PostLink href={`/${article.slug}`} locale={article.locale} postId={article.id} className="group">
                    <h3 className="sm:text-xl sm:leading-[31px] text-sm leading-[19.6px] font-bold text-[#333] group-hover:text-[#18af4e] transition-all duration-300 group-hover:text-[#18af4e]">
                        {article.title}
                    </h3>
                </PostLink>
                <div className="text-base leading-[24.8px] font-medium text-[#333] opacity-70">
                    {formatDateSimple(article.publishedAt)}
                </div>
            </div>
        </div>
    )
}

export default NewsGridItem
